import { Directive, ElementRef, HostListener } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
/**
 * Form directive
 */
@Directive({
  selector: '[appFocusInvalidElement]',
  exportAs: 'focusInvalidElement',
})
export class FormDirective {
  /**
   * constructor to inject dependency
   * @param elementRef instance of elementRef
   */
  constructor(private elementRef: ElementRef) {}

  /**
   * on form submit
   */
  @HostListener('submit')
  onFormSubmit() {
    const invalidControl = this.elementRef.nativeElement.querySelector('.is-invalid') as HTMLElement;
    if (invalidControl) {
      this.focusElement(invalidControl);
    }
  }

  /**
   * focus to element
   */
  private focusElement(element: HTMLElement) {
    if (element.textContent === 'Select') {
      this.findInputElement(element);
    } else if (element.children.length > 0) {
      (element.children[0] as HTMLElement).focus();
    } else {
      element.focus();
    }
  }

  /**
   * find the input with in PRIME NG elements
   * @param element HTML Element
   */
  private findInputElement(element: HTMLElement) {
    const elementCollection = element.children as HTMLCollection;

    for (let i = 0; i < elementCollection.length; i++) {
      if (elementCollection[i].tagName.toUpperCase() === 'INPUT') {
        (elementCollection[i] as HTMLElement).focus();
        break;
      } else {
        this.findInputElement(elementCollection[i].children[0] as HTMLElement);
      }
    }
  }
}
